import { TextAlignJustify } from "lucide-react";
import { createLucideIcon } from "./createLucideIcon";

export const TextAlignJustifyIcon = createLucideIcon(TextAlignJustify);
